import type { VerifyBeneficiaryDataResponseDtoOutput } from '@peanuds/shared';

import {
  closeMatchReasons,
  isKnownVerificationReason,
  verificationReasonToMessageKey,
} from './verify-beneficiary.constants';

export type VerificationStatus = 'matched' | 'close-match' | 'failed' | 'unknown';

export type VerificationViewModel = {
  reason: string | undefined;
  status: VerificationStatus;
  messageKey: string;
  accountHolderName: string | null;
  isVerified: boolean;
};

type VerificationData = VerifyBeneficiaryDataResponseDtoOutput['data'];

export const toVerificationViewModel = (
  verificationData: VerificationData | undefined,
): VerificationViewModel => {
  const reason = typeof verificationData?.reason === 'string' ? verificationData.reason : undefined;
  const isVerified = verificationData?.matched === true;

  if (isVerified) {
    return {
      reason,
      status: 'matched',
      messageKey: 'beneficiary.verify.success',
      accountHolderName: verificationData?.accountHolderName ?? null,
      isVerified,
    };
  }

  if (!reason) {
    return {
      reason,
      status: 'unknown',
      messageKey: 'beneficiary.verify.unknown',
      accountHolderName: verificationData?.accountHolderName ?? null,
      isVerified,
    };
  }

  if (closeMatchReasons.has(reason)) {
    return {
      reason,
      status: 'close-match',
      messageKey: verificationReasonToMessageKey['close-match'],
      accountHolderName: verificationData?.accountHolderName ?? null,
      isVerified,
    };
  }

  return {
    reason,
    status: 'failed',
    messageKey: isKnownVerificationReason(reason)
      ? verificationReasonToMessageKey[reason]
      : 'beneficiary.verify.unknown',
    accountHolderName: verificationData?.accountHolderName ?? null,
    isVerified,
  };
};
